import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, postRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import { TeamQueryParams } from 'types';

export const getTeams = async (queryParams: TeamQueryParams) => {
  const { sorting, others, all } = queryParams;
  const urlBuilder = createUrlBuilder('/projects');

  urlBuilder.addParameter('sorting', sorting);
  others && urlBuilder.addParameter('others', true);
  all && urlBuilder.addParameter('all', true);

  const result = await getRequest(LocateService, urlBuilder.toString());
  return result;
};

export const getTeamEnquirerList = async (params: any) => {
  const urlBuilder = createUrlBuilder(
    `/projects/${params.teamId}/enquiries`
  ).toString();

  return await getRequest(LocateService, urlBuilder);
};

export const generateTeamBaseMapToken = async (
  clientKey: string,
  clientSecret: string
) => {
  const body = {
    clientKey: clientKey,
    clientSecret: clientSecret
  };

  const urlBuilder = createUrlBuilder('/projects/basemaps/token').toString();

  return await postRequest(LocateService, urlBuilder, body);
};

export const uploadTeamBoundary = async (fileName: string) => {
  const urlBuilder = createUrlBuilder(`projects/boundary/upload`).toString();

  const body = {
    fileName
  };

  return await postRequest(LocateService, urlBuilder, body);
};

export const parseTeamBoundary = async (s3Key: string) => {
  const urlBuilder = createUrlBuilder(`projects/boundary/parse`).toString();

  const body = {
    s3Key
  };

  return await postRequest(LocateService, urlBuilder, body);
};

export const checkShapeWithinTeamBoundary = async (
  teamId: string,
  shape: any
) => {
  const urlBuilder = createUrlBuilder(
    `/projects/${teamId}/checkextend`
  ).toString();

  const body = {
    shape
  };

  return await postRequest(LocateService, urlBuilder, body);
};
